import * as React from 'react';

import OtherStepsSvg from '../../assets/other-steps.svg';

import styles from './onboarding-graphic-other-steps.module.css';

export class OnboardingGraphicOtherSteps extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles['other-steps']}>
                <OtherStepsSvg />
                <div className={styles.fade} />
            </div>
        );
    }
}
